import { ConfigOverrides } from './configOverrides'
import { assert } from 'torqcloud-ui'

export const firebaseConfig = {
  apiKey: ConfigOverrides.FIREBASE_API_KEY ?? process.env.REACT_APP_FIREBASE_API_KEY,
  appId: ConfigOverrides.FIREBASE_APP_ID ?? process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: ConfigOverrides.FIREBASE_AUTH_DOMAIN ?? process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: ConfigOverrides.FIREBASE_DATABASE_URL ?? process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: ConfigOverrides.FIREBASE_MESSAGING_SENDER_ID ?? process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: ConfigOverrides.FIREBASE_PROJECT_ID ?? process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: ConfigOverrides.FIREBASE_STORAGE_BUCKET ?? process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
}

export const gtmConfig = {
  containerId: ConfigOverrides.GTM_CONTAINER_ID ?? process.env.REACT_APP_GTM_CONTAINER_ID,
}

export const apiConfig = {
  API_BASE: ConfigOverrides.API_BASE ?? process.env.REACT_APP_API_BASE,
  API_VERSIONS: {
    V1: 'v1',
  },
}

export const appConfig = {
  APP_NAME: process.env.REACT_APP_NAME,
}

let _authenticationProvider: 'cognito' | 'keycloak'
switch (ConfigOverrides.AUTHENTICATION_PROVIDER ?? process.env.REACT_APP_AUTHENTICATION_PROVIDER) {
  case 'cognito':
  case '':
  case undefined:
  case null:
    _authenticationProvider = 'cognito'
    assert(ConfigOverrides.COGNITO_REGION ?? process.env.REACT_APP_COGNITO_REGION, 'REACT_APP_COGNITO_REGION not set')
    assert(ConfigOverrides.COGNITO_USER_POOL_ID ?? process.env.REACT_APP_COGNITO_USER_POOL_ID, 'REACT_APP_COGNITO_USER_POOL_ID not set')
    assert(ConfigOverrides.COGNITO_APP_CLIENT_ID ?? process.env.REACT_APP_COGNITO_APP_CLIENT_ID, 'REACT_APP_COGNITO_APP_CLIENT_ID not set')
    assert(ConfigOverrides.COGNITO_COOKIE_DOMAIN ?? process.env.REACT_APP_COGNITO_COOKIE_DOMAIN, 'REACT_APP_COGNITO_COOKIE_DOMAIN not set')

    break
  case 'keycloak':
    _authenticationProvider = 'keycloak'
    assert(ConfigOverrides.KEYCLOAK_URL ?? process.env.REACT_APP_KEYCLOAK_URL, 'REACT_APP_KEYCLOAK_URL not set')
    assert(ConfigOverrides.KEYCLOAK_CLIENT_ID ?? process.env.REACT_APP_KEYCLOAK_CLIENT_ID, 'REACT_APP_KEYCLOAK_CLIENT_ID not set')
    assert(ConfigOverrides.API_BASE ?? process.env.REACT_APP_API_BASE, 'REACT_APP_API_BASE not set')

    break
  default:
    throw new Error(
      `Unrecognized Authentication Provider ${ConfigOverrides.AUTHENTICATION_PROVIDER ?? process.env.REACT_APP_AUTHENTICATION_PROVIDER}`
    )
}

export const authenticationProviderType = _authenticationProvider

export const awsConfig = {
  region: ConfigOverrides.COGNITO_REGION ?? process.env.REACT_APP_COGNITO_REGION,
  userPoolId: ConfigOverrides.COGNITO_USER_POOL_ID ?? process.env.REACT_APP_COGNITO_USER_POOL_ID,
  appClientId: ConfigOverrides.COGNITO_APP_CLIENT_ID ?? process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  cookieDomain: ConfigOverrides.COGNITO_COOKIE_DOMAIN ?? process.env.REACT_APP_COGNITO_COOKIE_DOMAIN,
}

export const keycloakConfig = {
  authority: ConfigOverrides.KEYCLOAK_URL ?? process.env.REACT_APP_KEYCLOAK_URL,
  client_id: ConfigOverrides.KEYCLOAK_CLIENT_ID ?? process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  torqCloudBaseUrl: ConfigOverrides.API_BASE ?? process.env.REACT_APP_API_BASE,
}

export const torqFlowConfig = {
  baseUrl: ConfigOverrides.TORQFLOW_API_BASE_URL ?? process.env.REACT_APP_TORQFLOW_API_BASE_URL,
  appBaseUrl: ConfigOverrides.TORQFLOW_UI_BASE_URL ?? process.env.REACT_APP_TORQFLOW_UI_BASE_URL,
}

export const torqAgentConfig = {
  baseUrl: ConfigOverrides.TORQAGENT_API_BASE_URL ?? process.env.REACT_APP_TORQAGENT_API_BASE_URL,
}
